<template lang="pug">
div
  section.full__video.cinemagraph__section
    .cinemagraph__content--fullWidth.cinemagraph__content--mobile#marketers--topSection
      .affiliate__content
        h1 Become a Flixel Affiliate Partner
        p Love creating and sharing cinemagraphs? It's time to spread the love! Help us share the story of cinemagraphs and advocate for our visual storytelling tools.
        p By promoting our plans to your audience, you will earn attractive commissions on all sales you generate.
        .btn__group
          a(href='#signupForm')
            button.btn.btn--white Sign up
        
    .cinemagraph__content--fullWidth.cinemagraph__content--desktop.content__desktop--left
      .affiliate__content
        h1 Become a Flixel Affiliate Partner
        p Love creating and sharing cinemagraphs? It's time to spread the love! Help us share the story of cinemagraphs and advocate for our visual storytelling tools.
        p By promoting our plans to your audience, you will earn attractive commissions on all sales you generate.

    .fluid__video
      .video__overlay--shadow
      iframe(src='https://media.flixel.com/cinemagraph/3x9pcp2urtwbk2m9ihxm?hd=true')
      .credit
        a(target='_blank' href='https://flixel.com/virgohaan/') Virgo Haan

  section.landingPage__callout--form#signupForm
    .callout--container
      h1 Sign up Today
      form(v-on:submit.prevent='submitAffiliate(affiliate)')
        input(
          type='text'
          placeholder='Full Name'
          v-model='affiliate.fullName')
        input(
          type='email' 
          placeholder='Email'
          v-model='affiliate.email')
        button.btn(type='submit') Sign up
  section.landingPage__callout.landingPage__callout--white
    .callout--container.callout__affiliate
      h1 Your benefits as a Flixel Affiliate Partner
      ul
        li Earn 10% recurring commission on every purchase made using your coupon code
        li Monthly payouts
        li Social sharing assets
        li Personal customer support

  section.landingPage__callout
    .callout--container.callout__affiliate
      h1 Benefits for your customers
      ul
        li 10% off monthly and yearly plans
        li Access to all tutorials, tips and tricks
        li Personal customer support
        li Chance to be featured in galleries and on social media
      
  section.landingPage__callout--form
    .callout--container.affiliate__form
      h3 We look forward to partnering with you so be sure to get setup and started today!
      form(v-on:submit.prevent='submitAffiliate(affiliate)')
        input(
          type='text'
          placeholder='Full Name'
          v-model='affiliate.fullName')
        input(
          type='email'
          placeholder='Email'
          v-model='affiliate.email')
        button.btn(type='submit') Sign up
      .finePrint
        p By entering your email address you agree to be part of Flixel’s mailing list and receive information and news about our products. You can opt out at any time. 
          a(href='/privacy') See our privacy policy

</template>

<script>
import utilities from 'services/utilities.es6.js';

const axios = require('axios');

export default {
  name: 'affiliateLP',
  data() {
    return {
      affiliate: {
        fullName: '',
        email: '',
      },
    };
  },
  methods: {
    submitAffiliate(affiliateInfo) {
      event.preventDefault();
      const affiliateData = utilities.createFormData(affiliateInfo);
      const form = event.target;
      const message = document.createElement('p');
      axios({
        method: 'POST',
        url: 'https://apistaging.flixel.com/2/mailinglist/affiliates',
        data: affiliateData,
      }).then(function () {
        // Success
        form.innerHTML = '';
        message.innerText = 'Thanks for signing up! We will contact you to get started shortly. We look forward to partnering with you!';
        form.append(message);
      }).catch(function () {
        // Error
        form.innerHTML = '';
        message.innerText = 'There was an error with submitting this form. Please try again later.';
        form.append(message);
      });
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/views/landingPages/affiliate/affiliate.vue